/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_All_Team_Members_TextInputs */



/**
* | output |
* | --- |
* | "This guide is accessible to all team members." |
*
* @param {Knp_Guide_All_Team_Members_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_all_team_members_text = /** @type {((inputs?: Knp_Guide_All_Team_Members_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_All_Team_Members_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce guide est accessible à tous les membres de l’équipe.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Leitfaden ist für alle Teammitglieder zugänglich.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questa guida è accessibile a tutti i membri del team.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Данное руководство доступно всем членам команды.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Esta guía es accesible para todos los miembros del equipo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("所有团队成员均可查阅本指南。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このガイドはチームメンバー全員がアクセスできます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यह मार्गदर्शिका टीम के सभी सदस्यों के लिए उपलब्ध है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Este guia está disponível para todos os membros da equipe.")
	return /** @type {LocalizedString} */ ("This guide is accessible to all team members.")
});